'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGfAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#2DA446" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 0L28 20H0V0Z",
          fill: "#FFE24A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.9998 12.0979L11.5507 13.8709L12.4801 10.9938L10.0371 9.21243L13.0606 9.20723L13.9998 6.33333L14.9391 9.20723L17.9626 9.21243L15.5196 10.9938L16.4489 13.8709L13.9998 12.0979Z",
          fill: "#E7242C"
        }
      )
    ]
  }
);
const VpFlagGfAsset = forwardRef(FlagGfAsset);

export { VpFlagGfAsset as default };
